import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const manageProductsApi = createApi({
    reducerPath: "manageProductsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    
    tagTypes: ["Products"], 
    endpoints: (builder) => ({
        getAllProducts: builder.query({
            query: () => ({
                url: "/Product/all-product",
                method: "GET",
            }),
            
            providesTags: ["Products"],
        }),
    }),
});

export const { useGetAllProductsQuery } = manageProductsApi;